import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const STORY = [
  "I’m Blake Smith, founder of The Blake Smith Company in Huntsville, Alabama. As a barber, DJ, and business owner, I’ve learned firsthand what it takes to turn an idea into something people support.",
  "I started this company to help other entrepreneurs do the same. Through websites, marketing, and digital tools, we help businesses tell their story, reach customers, and make their next move.",
];

export default function FounderPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Meet the Founder | The Blake Smith Company LLC";
    return () => { document.title = "The Blake Smith Company LLC | Marketing, Websites & Mobile Apps"; };
  }, []);

  return (
    <section className="founder" data-testid="founder-page">
      <div className="shell founder-inner">
        <motion.div
          className="founder-photo-frame"
          initial={{ scale: 0.97 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <picture>
            <source srcSet="/assets/blake_smith_founder.webp" type="image/webp" />
            <img src="/assets/blake_smith_founder.jpg" alt="Blake Smith, founder of The Blake Smith Company" width="900" height="1182" loading="eager" decoding="async" data-testid="founder-photo" />
          </picture>
        </motion.div>
        <div className="founder-copy">
          <Reveal as="p" className="founder-eyebrow">MEET THE FOUNDER</Reveal>
          <Reveal as="h1" delay={0.08} className="founder-name" data-testid="founder-name">Blake Smith</Reveal>
          <Reveal as="p" delay={0.12} className="founder-role">Founder, The Blake Smith Company · Huntsville, Alabama</Reveal>
          <div className="gold-rule founder-rule" />
          {STORY.map((p, i) => (
            <Reveal as="p" key={i} delay={0.16 + i * 0.08} className="founder-text">{p}</Reveal>
          ))}
          <Reveal delay={0.3}>
            <Link to="/#contact" className="btn btn-gold" data-testid="founder-contact-btn">
              Work With Blake <ArrowRight size={18} strokeWidth={2.4} aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
